// Fade + rise entrance for every homepage/page section as it scrolls into
// view — an original IntersectionObserver-based implementation (not tied to
// Dawn's own scroll-trigger system, since this theme's custom sections don't
// consistently opt into that), so this "just works" regardless of section
// type. Whole-section reveal rather than per-element stagger, since we don't
// know each custom section's internal markup ahead of time.
(function () {
  function init() {
    var targets = document.querySelectorAll("#MainContent .shopify-section");
    if (!targets.length) return;

    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!("IntersectionObserver" in window) || prefersReducedMotion) {
      targets.forEach(function (el) {
        el.classList.add("sanda-reveal-visible");
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("sanda-reveal-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -80px 0px" },
    );

    targets.forEach(function (el, i) {
      // First section (hero) is visible on load — don't make shoppers wait
      // for a fade-in on the very first thing they see.
      if (i === 0) {
        el.classList.add("sanda-reveal-visible");
        return;
      }
      el.classList.add("sanda-reveal");
      io.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
